import { baseApi } from './base.api'

export const autenticacionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Solicita tokens OAuth con usuario y password capturados en login.
     * `baseApi` agrega Basic Auth y content-type form-urlencoded para este endpoint.
     */
    iniciarSesion: builder.mutation({
      query: (credenciales) => {
        return {
          url: '/sec/a/t',
          method: 'POST',
          body: new URLSearchParams({
            username: credenciales.username,
            password: credenciales.password,
            grant_type: 'password',
          }),
        }
      },
    }),
  }),
})

export const datosUsuarioApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Recupera el usuario autenticado con roles, sitios y datos funcionales para rutas y menu.
     */
    recuperarDatosUsuario: builder.query({
      query() {
        return { url: '/u' }
      },
    }),
    recuperarDatosUsuarioMut: builder.mutation({
      query() {
        return {
          url: '/u',
          method: 'GET',
        }
      },
    }),
  }),
})

export const { useIniciarSesionMutation } = autenticacionApi
export const { useRecuperarDatosUsuarioQuery, useRecuperarDatosUsuarioMutMutation } =
  datosUsuarioApi
